import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoDepot } from '../interfaces/dto.depot.interface';
import { IDtoContact } from '../interfaces/dto.contact.interface';
import { DtoContact } from './dto.contact';

// @dynamic
@JsonObject('DtoDepot')
export class DtoDepot extends ModelEntity implements IDtoDepot {

    constructor(initValues: Partial<IDtoDepot> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('accountPrefix', String, true)
    public accountPrefix?: string = null;

    @JsonProperty('numberDepot', String, true)
    public numberDepot?: string = null;

    @JsonProperty('name', String, true)
    public name?: string = null;

    @JsonProperty('contacts', [DtoContact], true)
    public contacts?: IDtoContact[] = [];

    public get completeDescription(): string {
        return UtilsString.stringFormat('{0} - {1}', this.numberDepot, this.name);
    }

}
